import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (params) {
  const { data, exec } = useRequest({
    url: ``,
    name: 'GET_ORDER_CRAFT_MONITOR_MAIN',
    method: 'GET',
  });
  useEffect(() => {
    if (params != null) {
      let url = '/api/production/order/craft/monitor/main';
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
  }, [params]); // eslint-disable-line react-hooks/exhaustive-deps
  return [data || [], exec];
});
